import Vue from "vue";
import Vuex from "vuex";
import service from "../../services/cargaDeLicencias/licenses";
import licenses from '../../models/cargaDeLicencias/licenses'
import license from "../../models/cargaDeLicencias/licenses";
Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        service: new service(),
        licenses: [],
        filter: {},
        new: [],
        deleteItem: null,
        deleteItemDetail: null,
        edit: {},
        editDetail: {},
        editLicense: {},
        license: [],
        open: false,
        mode: 'Agregar licens',
        openDelete: false,
    },

    mutations: {
        setLicenses(state, data) {
            state.licenses = data;
        },
        setLicense(state, data) {
            state.license = data
        },
        setEditLicense(state, data) {
            state.editLicense = data
        },
        setNew(state, data) {
            state.new = data
        },
        setDeleteItem(state, data) {
            state.deleteItem = data
        },
        setDeleteItemDetail(state, data) {
            state.deleteItemDetail = data
        },
        setEdit(state, data) {
            state.edit = data
        },
        setEditDetail(state, data) {
            state.editDetail = data
        },
        setOpen(state, data) {
            state.open = data
        },
        setMode(state, data) {
            state.mode = data
        },
        setOpenDelete(state, data) {
            state.openDelete = data;
        },
        setItemDelete(state, data) {
            state.itemDelete = data;
        },


    },
    actions: {
        //get all licenses
        //si hay filtros hay que mandarlos sino nothing

        async getLicenses(state, payload) {
            return new Promise(async (resolve, reject) => {
                try {
                    let item = await state.state.service.getLicenses(payload); // Pasamos el payload opcionalmente
                    state.commit("setLicenses", item);
                    resolve(true);
                } catch (error) {
                    reject(error);
                }
            });
        },

        //get license licenseId
        async getLicenceDetails(state) {
            return new Promise(async (resolve, reject) => {
                try {
                    let item = await state.state.service.getLicenseDetail(state.state.edit.procId);
                    state.commit("setLicense", item);
                    resolve(true);
                } catch (error) {
                    reject(error);
                }
            });
        },
        async new(state) {
            return new Promise(async (resolve, reject) => {
                try {
                    await state.state.service.new(state.state.new).then((data) => {
                        state.dispatch("getLicenses").then(() => {
                            resolve(true)
                        })
                    })
                }
                catch (error) {
                    reject(error)
                }
            })

        },

        async edit(state) {
            return new Promise(async (resolve, reject) => {
                try {
                    await state.state.service.edit(state.state.editLicense).then(() => {
                        state.dispatch("getLicenses").then(() => {
                            resolve(true)
                        })
                    })
                }
                catch (error) {
                    reject(error)
                }
            })

        },

        async delete(state) {
            return new Promise(async (resolve, reject) => {
                try {
                    await state.state.service.delete(state.state.deleteItem).then(() => {

                        let options = state.state.licenses;
                        options = options.filter((option) => {
                            return option.procId !== state.state.deleteItem;
                        });

                        state.commit('setLicenses', options)
                        resolve(true)
                    });
                } catch (error) {
                    reject(error)

                }
            })

        },
        async editDetail(state) {
            return new Promise(async (resolve, reject) => {
                try {
                    await state.state.service.editDetail(state.state.editDetail).then(() => {
                        resolve(true)
                    })
                }
                catch (error) {
                    reject(error)
                }
            })

        },

        async deleteDetail(state) {
            return new Promise(async (resolve, reject) => {
                try {
                    await state.state.service.deleteDetail(state.state.deleteItemDetail).then(() => {
                        let options = state.state.license;
                        options = options.filter((option) => {
                            return option.liId !== state.state.deleteItemDetail.liId;
                        });
                        state.commit('setLicense', options)
                        resolve(true)
                    });
                } catch (error) {
                    reject(error)

                }
            })

        },

        async process(state, payload) {
            return new Promise(async (resolve, reject) => {
                try {
                    await state.state.service.process(payload).then(() => {
                        state.dispatch("getLicenses").then(() => {
                            resolve(true)
                        })
                    })
                } catch (error) {
                    reject(error);
                }
            });
        },


    },
});
